export const ADD_TO_CART = "ADD_TO_CART";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const ADD_STUDENT_TO_SHOP_CART = "ADD_STUDENT_TO_SHOP_CART";
export const DELETE_STUDENT_FROM_SHOP_CART = "DELETE_STUDENT_FROM_SHOP_CART";
export const CLEAN_SHOP_CART = "CLEAN_SHOP_CART";
export const SET_LASTADDED_ITEM = "SET_LASTADDED_ITEM";
export const DELETE_MANY_STUDENTS_FROM_SHOP_CART_AND_LAST_ADDED =
  "DELETE_MANY_STUDENTS_FROM_SHOP_CART_AND_LAST_ADDED";
export const ADD_MANY_STUDENTS_FROM_SHOP_CART_AND_LAST_ADDED =
  "ADD_MANY_STUDENTS_FROM_SHOP_CART_AND_LAST_ADDED";
// Add item to cart
export function addToCart(prod) {
  return {
    type: ADD_TO_CART,
    payload: prod,
  };
}

// Remove item from cart
export function deleteFromCart(fortnoxNumber) {
  return {
    type: DELETE_FROM_CART,
    payload: fortnoxNumber,
  };
}

// Add student to cart item
export function addStudentToCartItem(student, fortnoxNumber) {
  return {
    type: ADD_STUDENT_TO_SHOP_CART,
    payload: { student: student, fortnoxNumber: fortnoxNumber },
  };
}

// Remove student from cart item
export function removeStudentFromCartItem(student, fortnoxNumber) {
  return {
    type: DELETE_STUDENT_FROM_SHOP_CART,
    payload: { student: student, fortnoxNumber: fortnoxNumber },
  };
}

export function removeManyStudentsFromCartAndLastAdded(
  studentIds,
  fortnoxNumber
) {
  return {
    type: DELETE_MANY_STUDENTS_FROM_SHOP_CART_AND_LAST_ADDED,
    payload: { studentIds: studentIds, fortnoxNumber: fortnoxNumber },
  };
}

export function addManyStudentsFromCartAndLastAdded(students, fortnoxNumber) {
  return {
    type: ADD_MANY_STUDENTS_FROM_SHOP_CART_AND_LAST_ADDED,
    payload: { students: students, fortnoxNumber: fortnoxNumber },
  };
}

// Clear cart after shopping
export function clearCart() {
  return {
    type: CLEAN_SHOP_CART,
  };
}

//Add last added item
export function setLastAddedItem(lastAddedItem) {
  return {
    type: SET_LASTADDED_ITEM,
    payload: lastAddedItem,
  };
}
